import { render, staticRenderFns } from "./qCardStatus.vue?vue&type=template&id=3573625c&scoped=true&"
import script from "./qCardStatus.vue?vue&type=script&lang=js&"
export * from "./qCardStatus.vue?vue&type=script&lang=js&"
import style0 from "./qCardStatus.vue?vue&type=style&index=0&id=3573625c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573625c",
  null
  
)

export default component.exports